import Prototype from "./Prototype";

export function SessionStatus({ error }: { error?: string }) {
  const back = () => {
    if (window.wx?.miniProgram?.reLaunch) {
      window.wx.miniProgram.reLaunch({ url: "/pages/index/index" });
      return;
    }
    if (window.wx?.miniProgram?.navigateBack) {
      window.wx.miniProgram.navigateBack({ delta: 1 });
      return;
    }
    if (window.history.length > 1) window.history.back();
    else window.location.replace("/");
  };

  return (
    <main className="session-status" role={error ? "alert" : "status"}>
      <span>BEAUTINOW SEARCH</span>
      <h1>{error ? "暂时无法进入搜索" : "正在进入专业香水搜索"}</h1>
      <p>{error || "正在准备搜索服务…"}</p>
      {error ? <button type="button" onClick={back}>返回小程序重新进入</button> : null}
    </main>
  );
}

export default function App() {
  return (
    <main className="h5-app" aria-label="Beautinow 香水搜索与匹配">
      <Prototype />
    </main>
  );
}
